import { throwError } from '@/utils'
import { md5 } from 'js-md5'
import { Handler } from 'mitt'
import appExpose from '@app/expose'

const { config, emitter } = appExpose

let appId = '110000049'
let appKey = '97cf1bdea7d95b7d686c63ee52c10add'

export function objKeySort(params: { [key: string]: unknown }) {
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  let newkey = Object.keys(params).sort()
  /** @type {Record<string, unknown>} */
  let newObj = {} //创建一个新的对象，用于存放排好序的键值对
  for (let i = 0; i < newkey.length; i++) {
    // @ts-ignore 遍历newkey数组
    newObj[newkey[i]] = params[newkey[i]]
    //向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj //返回排好序的新对象
}

export function signFormat(reqdata = {}) {
  let params: Record<string, unknown> = {
    clientversion: '1.0',
    lang: window.lang || config.defaultLang,
    appid: appId,
    securemode: 'MD5',
    timestamp: new Date().getTime().toString().slice(0, 10),
  }
  //对业务参数进行urlEncode
  params.reqdata = encodeURIComponent(JSON.stringify(reqdata))
  //对所有参数进行排序
  let sortParam = objKeySort(params)
  let beforeMd5 = JSON.stringify(sortParam) + appKey
  //把sign塞入请求参数
  params.sign = md5(beforeMd5).toString()
  return JSON.stringify(params)
}

export function loginMessageIsString(data: LoginMessage): data is string {
  return typeof data === 'string'
}

export function setToken(loginData: LoginMessage) {
  if (loginMessageIsString(loginData)) return

  const token = loginData.token
  if (typeof token === 'string' && token.length > 0) {
    window.macaddr = token
    localStorage.setItem(md5('1'), window.btoa(JSON.stringify(loginData)))
  }
}

export function getToken() {
  if (typeof window.macaddr === 'string' && window.macaddr.length > 0)
    return window.macaddr

  let token = ''
  try {
    const loginData: LoginMessage = JSON.parse(
      window.atob(window.localStorage.getItem(md5('1')) || window.btoa('{}'))
    )
    if (!loginMessageIsString(loginData)) {
      token = loginData.token
    }
  } catch (error) {
    throwError(error)
  }
  return token || ''
}

export function clearToken() {
  window.macaddr = undefined
  localStorage.removeItem(md5('1'))
}

export function logout(alert?: string, rejectClose = false, go2login = false) {
  emitter.emit('logout', { alert, rejectClose, go2login })
}

export function createServerName(_serverId: string | number) {
  let serverName = ''
  let serverId = _serverId
  serverId = String(serverId)
  if (!serverId.slice(1)) {
    serverName = `<span class="text-nowrap">[S-${serverId}]</span>`
  } else {
    serverName = `<span class="text-nowrap">[S-${parseInt(
      serverId.slice(1)
    )}]</span>`
  }
  return serverName
}

export function createServerName2(_serverId: string | number) {
  let serverName = ''
  let serverId = _serverId
  serverId = String(serverId)
  if (!serverId.slice(1)) {
    serverName = `S${serverId}`
  } else {
    serverName = `S${parseInt(serverId.slice(1))}`
  }
  return serverName
}

export function checkPlayer(source?: CheckPlayerEvent['source']) {
  return new Promise<boolean>((resolve) => {
    const _handler: Handler<boolean> = (e) => {
      emitter.off('checkPlayerReturn', _handler)
      resolve(e)
    }
    emitter.on('checkPlayerReturn', _handler)
    emitter.emit('checkPlayer', { source })
  })
}
